"use strict";
var _a, _b, _c, _d, _e, _f, _g;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Insurer = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const insurer_address_entity_1 = require("./insurer-address.entity");
const insurer_contact_entity_1 = require("./insurer-contact.entity");
const look_up_entity_1 = require("./look-up.entity");
let Insurer = class Insurer {
};
exports.Insurer = Insurer;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({ type: "int" }),
    tslib_1.__metadata("design:type", Number)
], Insurer.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "name", type: "varchar", length: 200 }),
    tslib_1.__metadata("design:type", String)
], Insurer.prototype, "insurerName", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "display_name", type: "varchar", length: 100 }),
    tslib_1.__metadata("design:type", String)
], Insurer.prototype, "displayName", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "company_type_lid", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], Insurer.prototype, "companyTypeLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "website", type: "varchar", nullable: true }),
    tslib_1.__metadata("design:type", String)
], Insurer.prototype, "website", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "is_life_lid", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], Insurer.prototype, "isLifeLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "company_tag_lid", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], Insurer.prototype, "companyTagLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "remarks", type: "varchar", nullable: true, length: 500 }),
    tslib_1.__metadata("design:type", String)
], Insurer.prototype, "remarks", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "insure_code", type: "varchar", nullable: true, length: 100 }),
    tslib_1.__metadata("design:type", String)
], Insurer.prototype, "insureCode", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "status_lid", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], Insurer.prototype, "statusLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], Insurer.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], Insurer.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({ name: "created_at", type: "timestamp" }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], Insurer.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({ name: "updated_at", type: "timestamp" }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], Insurer.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.DeleteDateColumn)({ name: "deleted_at", type: "timestamp", nullable: true }),
    tslib_1.__metadata("design:type", typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object)
], Insurer.prototype, "deletedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "is_life_lid", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", typeof (_d = typeof look_up_entity_1.LookUp !== "undefined" && look_up_entity_1.LookUp) === "function" ? _d : Object)
], Insurer.prototype, "isLife", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "company_type_lid", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", typeof (_e = typeof look_up_entity_1.LookUp !== "undefined" && look_up_entity_1.LookUp) === "function" ? _e : Object)
], Insurer.prototype, "companyType", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "company_tag_lid", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", typeof (_f = typeof look_up_entity_1.LookUp !== "undefined" && look_up_entity_1.LookUp) === "function" ? _f : Object)
], Insurer.prototype, "companyTag", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "status_lid", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", typeof (_g = typeof look_up_entity_1.LookUp !== "undefined" && look_up_entity_1.LookUp) === "function" ? _g : Object)
], Insurer.prototype, "status", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => insurer_address_entity_1.InsurerAddress, (insurerAddress) => insurerAddress.insurer, {
        cascade: true,
    }),
    tslib_1.__metadata("design:type", Array)
], Insurer.prototype, "insurerAddresses", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => insurer_contact_entity_1.InsureContact, (insurerContact) => insurerContact.insurer, {
        cascade: true,
    }),
    tslib_1.__metadata("design:type", Array)
], Insurer.prototype, "insurerContacts", void 0);
exports.Insurer = Insurer = tslib_1.__decorate([
    (0, typeorm_1.Entity)({ name: "insurer" })
], Insurer);
